import Title from '../../microComponents/elements/Title';
import ComponentCard from '../../microComponents/elements/ComponentCard';
import UseSetParams from '../../microComponents/tablePages/filter/UseSetParams';
import DeleteFilterTable from '../../microComponents/tablePages/filter/DeleteFilterTable';
import CreatorTable from '../../microComponents/tablePages/CreatorTable';
import PalletStatusColumn from './PalletStatusColumn';
import React, {useEffect} from "react";
import ShowSearchBtn from "../../microComponents/tablePages/ShowSearchBtn";
import CollapseBox from "../../microComponents/tablePages/CollapseBox";
import {useDispatch, useSelector} from "react-redux";
import TopSearchPalletStatus from "./TopSearchPalletStatus";
import QcModal from "./QcModal";
import EntryModal from "./EntryModal";
import OrderModal from "./OrderModal";
import {Button} from "antd";
import {handleEntry, handleOrder, handleQc} from "../../store/SettingRedux/SettingRedux";
import ExpandedPalletStatus from "./ExpandedPalletStatus";
import {useNavigate} from "react-router-dom";


const PalletStatus = () => {
    const navigate = useNavigate();

    const dispatch = useDispatch();

    const qc = useSelector((state) => state.SettingRedux.qc);
    const entry = useSelector((state) => state.SettingRedux.entry);
    const order = useSelector((state) => state.SettingRedux.order);
    const [columns] = PalletStatusColumn();
    const [, handleDeleteParams] = UseSetParams();
    const showSearchBox = useSelector((state) => state.TableRedux.showSearchBox);

    useEffect(() => {
        dispatch(handleQc(null))
        dispatch(handleEntry(null))
        dispatch(handleOrder(null))
    }, [dispatch])
    return (<div>
            <ComponentCard>
                <div className='flex justify-between items-center'>
                    <Title>وضعیت شناسه ها</Title>


                    <div className='flex gap-1'>
                        {
                            (qc || entry || order) ?
                                <Button className='defBtn orangeBtn !px-10' onClick={() => {

                                    dispatch(handleQc(null))
                                    dispatch(handleEntry(null))
                                    dispatch(handleOrder(null))
                                }}>اتمام</Button>
                                :
                                <>
                                    <QcModal/>
                                    <EntryModal/>
                                    <OrderModal/>
                                </>

                        }

                    </div>
                    <div className='flex gap-2 items-center'>
                        <DeleteFilterTable onClick={handleDeleteParams}/>
                        <ShowSearchBtn/>
                    </div>
                </div>

                <div className='searchBox p-0'>
                    <CollapseBox activeKey={showSearchBox ? ['1'] : null} items={[{
                        showArrow: false, headerPadding: '1px', className: 'bg-white border-none',
                        key: '1', children: <TopSearchPalletStatus/>,
                    }]}/>

                </div>
            </ComponentCard>


            <ComponentCard>


                <CreatorTable columns={columns} listAddress='pallet' rowKey='palletId'
                              onDoubleClickRowHandler={(row) => {
                                  navigate(`/transaction/${row.palletId}`);

                              }}


                              expandable={{
                                  expandedRowRender: (row) => (

                                      <ExpandedPalletStatus item={row}/>

                                  ),
                                  // rowExpandable: (record) => record.name !== 'Not Expandable',
                              }}/>

                {/*</CheckPermissionPage>*/}
            </ComponentCard></div>
    );
};


export default PalletStatus;